// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"beb34e66","321":"5fd7b406","532":"9f62acf2","661":"9f62acf2"}[chunkId] + ".chunk.css";
};